import Layout from '@/components/layout/Layout.vue';

export default {
    path: '/',
    component: Layout,
    children: [
        {
            path: 'index',//首页
            name: 'Index',
            component: () => import('@/views/Index.vue'),
            meta: {navBar: {show: false, title: '首页'}, tabBar: {show: true, active: 0}, depth:1}
        },
        {
            path: 'newArrival',//最新上架-BookBlock组件
            name: 'NewArrival',
            component: () => import('@/views/NewArrival.vue'),
            meta: {navBar: {show: true, title: '最新上架'}, tabBar: {show: false, active: 0}, backTop: true,keepAlive:true, depth:2}
        },
        {
            path: 'newBook',//新书速递-BookBlock组件
            name: 'NewBook',
            component: () => import('@/views/NewBook.vue'),
            meta: {navBar: {show: true, title: '新书速递'}, tabBar: {show: false, active: 0}, backTop: true,keepAlive:true, depth:2}
        },
        {
            path: 'recommend',//推荐图书-BookBlock组件
            name: 'Recommend',
            component: () => import('@/views/Recommend.vue'),
            meta: {navBar: {show: true, title: '推荐图书'}, tabBar: {show: false, active: 0}, backTop: true,keepAlive:true, depth:2}
        },
        {
            path: 'searchResults',//搜索结果-BookBlock组件
            name: 'SearchResults',
            component: () => import('@/views/SearchResults.vue'),
            meta: {navBar: {show: true, title: '搜索结果'}, tabBar: {show: false, active: 0}, backTop: true,keepAlive:true, depth:2}
        },
        {
            path: 'advancedSearch',//高级搜索
            name: 'AdvancedSearch',
            component: () => import('@/views/AdvancedSearch.vue'),
            meta: {navBar: {show: true, title: '高级搜索'}, tabBar: {show: false, active: 0}}
        },
        {
            path: 'bookDetail/:bookId',//书本详情
            name: 'BookDetail',
            props: true,
            component: () => import('@/views/BookDetail.vue'),
            meta: {navBar: {show: true, title: '书本详情', showShopCart: true}, tabBar: {show: false, active: 0}, backTop: true, depth:3}
        },{
            path: 'orderBookDetail/:bookId',//已下单的书本详情
            name: 'OrderBookDetail',
            props: true,
            component: () => import('@/views/OrderBookDetail.vue'),
            meta: {navBar: {show: true, title: '书本详情', showShopCart: true}, tabBar: {show: false, active: 0}, backTop: true, loginBlocking: true}
        },
        {
            path: 'catalog',//书目分类
            name: 'Catalog',
            component: () => import('@/views/Catalog.vue'),
            meta: {navBar: {show: false, title: '书目分类'}, tabBar: {show: true, active: 1}}
        },
        {
            path: 'catalogList/:id',//书目二级分类-BookBlock组件
            name: 'CatalogList',
            props: true,
            component: () => import('@/views/CatalogList.vue'),
            meta: {navBar: {show: true, title: '二级分类'}, tabBar: {show: true, active: 1},keepAlive:true,depth:2}
        },
        {
            path: 'shopCart',//购物车
            name: 'ShopCart',
            component: () => import('@/views/ShopCart.vue'),
            meta: {navBar: {show: true, title: '购物车'}, tabBar: {show: false, active: 2}, loginBlocking: true}
        },
        {
            path: 'personalCenter',//个人中心
            name: 'PersonalCenter',
            component: () => import('@/views/PersonalCenter.vue'),
            meta: {navBar: {show: false, title: '个人中心'}, tabBar: {show: true, active: 3},  loginBlocking: true}
        },
        {
            path: 'personalInfo',//个人信息
            name: 'PersonalInfo',
            component: () => import('@/views/PersonalInfo.vue'),
            meta: {navBar: {show: true, title: '个人信息'}, tabBar: {show: true, active: 3}, loginBlocking: true}
        },
        {
            path: 'receivingAddress',//收货地址-和receivingAddressPick组件框架一样
            name: 'ReceivingAddress',
            component: () => import('@/views/ReceivingAddress.vue'),
            meta: {navBar: {show: true, title: '收货地址'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'receivingAddressEdit',//编辑收货信息
            name: 'ReceivingAddressEdit',
            component: () => import('@/views/ReceivingAddressEdit.vue'),
            meta: {navBar: {show: true, title: '收货信息'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'toBeConfirmed',//待确认
            name: 'ToBeConfirmed',
            component: () => import('@/views/ToBeConfirmed.vue'),
            meta: {navBar: {show: true, title: '待提交'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'receivingAddressPick',//选择收货地址-和receivingAddress组件框架一样
            name: 'ReceivingAddressPick',
            component: () => import('@/views/ReceivingAddressPick.vue'),
            meta: {navBar: {show: true, title: '选择收货地址'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'allOrder',//全部订单
            name: 'AllOrder',
            component: () => import('@/views/AllOrder.vue'),
            meta: {navBar: {show: true, title: ''}, tabBar: {show: false, active: 3}, backTop: true, loginBlocking: true}
        },
        {
            path: 'orderDetail/:orderId',//订单详情-Book组件
            name: 'OrderDetail',
            props: true,
            component: () => import('@/views/OrderDetail.vue'),
            meta: {navBar: {show: true, title: '订单详情'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'currentBorrow',//当前在借-BookBlock组件
            name: 'CurrentBorrow',
            component: () => import('@/views/CurrentBorrow.vue'),
            meta: {navBar: {show: true, title: '当前在借'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
        {
            path: 'borrowHistory',//借阅历史-BookBlock组件
            name: 'BorrowHistory',
            component: () => import('@/views/BorrowHistory.vue'),
            meta: {navBar: {show: true, title: '借阅历史'}, tabBar: {show: false, active: 3}, backTop: true, loginBlocking: true}
        },
        {
            path: 'shopOrderDetail',// 购物车订单详情
            name: 'ShopOrderDetail',
            component: () => import('@/views/ShopOrderDetail.vue'),
            meta: {navBar: {show: true, title: '购物车订单详情'}, tabBar: {show: false, active: 3}, loginBlocking: true}
        },
    ]
};
/* 有backTop的页面有7个
--------------------------
NewArrival
NewBook
Recommend
SearchResults
BookDetail
AllOrder
BorrowHistory
-------------------------- */
